import { render, staticRenderFns } from "./RoomTypePopularityReport.vue?vue&type=template&id=848e6026&scoped=true"
import script from "./RoomTypePopularityReport.vue?vue&type=script&lang=js"
export * from "./RoomTypePopularityReport.vue?vue&type=script&lang=js"
import style0 from "./RoomTypePopularityReport.vue?vue&type=style&index=0&id=848e6026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848e6026",
  null
  
)

export default component.exports